<template>
  <div>
    <v-card
      flat
      :loading="loading"
      class="tab-details"
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-text>
        <div class="mx-12 text-h6 font-weight-black mt-3 text-c-green">
          {{ local.caseFile.tabHeaders.fees }}
        </div>
        <v-row class="mx-12">
          <v-col
            v-if="items.length"
            cols="12"
          >
            <naj-item-table
              :data-items="items"
              :headers="headers"
              :loading="loading"
              :items-per-page="(items||[]).length"
              :server-items-length="(items||[]).length"
              :enable-expand="true"
              @expandSlot="getBillDetails"
            >
              <template
                slot="invoiceNo"
                slot-scope="{item}"
              >
                <div class="info-item-details-title pt-0">
                  <div class="d-flex font-weight-black header-text">
                    <div class="pa-3 ml-auto text-c-dark pl-4 pr-0 pb-1  info-item-details-title">
                      {{ local.judicialFees.headers.invoiceNo }}
                    </div>
                    <div class="mt-0">
                      <v-chip
                        color="var(--app-primary-color)"
                        class="br0"
                      >
                        {{ item.providerName }}
                      </v-chip>
                    </div>
                  </div>
                </div>
                <div class="info-item-details-value mt-2">
                  {{ item.invoiceNo }}
                </div>
              </template>

              <template
                slot="expandButtonText"
                slot-scope="{ }"
              >
                <div class="text-center">
                  {{ local.judicialFees.details }}
                </div>
                <div class="text-center">
                  {{ local.judicialFees.bill }}
                </div>
              </template>
              <template
                slot="action"
                slot-scope="{item}"
              >
                <div class="mx-4">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">
                        mdi-dots-vertical
                      </v-icon>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title>
                          <div>
                            <naj-button
                              text
                              type="button"
                              size="small"
                              @click="showBillTimelineModal(item.objectKey)"
                            >
                              {{ local.judicialFees.billTimeline }}
                            </naj-button>
                          </div>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="!item.objectionRequestCode && item.remainingObjectionDays>0">
                        <v-list-item-title>
                          <div>
                            <naj-button
                              text
                              type="button"
                              size="small"
                              @click="showCreateBillObjectionRequest(item.objectKey, item.providerId)"
                            >
                              {{ local.judicialFees.objectionRequest }}
                            </naj-button>
                          </div>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>

              <template
                slot="expandSlot"
                slot-scope="{ item }"
              >
                <v-row v-if="!item.isLoading">
                  <v-col
                    cols="6"
                    class=" mt-3"
                  >
                    <div class="header-text font-weight-bold">
                      {{ local.judicialFees.billDetails }}
                    </div>
                    <bill-attributes
                      :attributes="item.attributes"
                      :provider="item.providerId"
                    ></bill-attributes>
                    <div class="header-text font-weight-bold">
                      {{ local.judicialFees.billFeeDetails }}
                    </div>
                    <bill-item-details
                      :item-details="item.itemDetails"
                      :provider="item.providerId"
                    ></bill-item-details>
                    <div
                      v-if="item.isBillUpdated"
                      class="header-text font-weight-bold pt-3"
                    >
                      {{ (item.billUpdateDetails||{}).actionTypeId == billActionTypeEnum.refundDone ?
                        local.judicialFees.billRefundDetails.title
                        :local.judicialFees.billUpdateDetails.title }}
                    </div>
                    <bill-update-details
                      v-if="item.isBillUpdated"
                      :update-details="item.billUpdateDetails"
                    ></bill-update-details>
                  </v-col>
                  <v-col
                    cols="6"
                    class="objection-box mt-3"
                  >
                    <div class="header-text font-weight-bold">
                      {{ local.judicialFees.billFeeObjection }}
                    </div>

                    <template v-if="!item.objectionRequestCode && item.remainingObjectionDays>0">
                      <naj-alert type="alert">
                        <template slot="content">
                          {{ local.judicialFees.dearCustomer }} {{ local.judicialFees.objectionHeader }}
                        </template>
                      </naj-alert>

                      <div class="d-flex justify-content-center align-items-center pt-8">
                        <naj-button @click="showCreateBillObjectionRequest(item.objectKey, item.providerId)">
                          {{ local.judicialFees.billObjectionRequest }}
                        </naj-button>
                      </div>
                    </template>

                    <template v-if="!item.objectionRequestCode && item.remainingObjectionDays == 0">
                      <naj-alert type="information">
                        <template slot="content">
                          {{ local.judicialFees.dearCustomer }} {{ local.judicialFees.objectionDueDateHeader }}
                        </template>
                      </naj-alert>
                    </template>

                    <template v-if="item.objectionRequestCode">
                      <objection-request-info :bill="item"></objection-request-info>
                    </template>
                  </v-col>
                </v-row>
              </template>
            </naj-item-table>

            <bill-timeline-modal
              ref="billTimelineModal"
              :modal-visibility="selectedBillObjectKey != null"
              :bill-object-key="selectedBillObjectKey"
              @billTimelineModalClose="selectedBillObjectKey=null"
            ></bill-timeline-modal>

            <objection-request-modal
              v-if="selectedBillObjectKeyForObjection!=null"
              ref="objectionRequestModal"
              :modal-visibility="true"
              :bill-object-key="selectedBillObjectKeyForObjection"
              :provider-id="selectedBillProviderIdForObjection"
              @objectionRequestModalClose="objectionRequestModalClose"
            >
            </objection-request-modal>
          </v-col>
          <v-col cols="12">
            <naj-no-data
              :has-data="items && items.length > 0"
              :loading="loading"
            ></naj-no-data>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { billActionType as billActionTypeEnum } from '@/helpers/enum';
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapActions: mapJudicialFeesActions } = createNamespacedHelpers('JudicialFeesModule');
import { toHijriDate } from '@/helpers/utils';
import BillTimelineModal from '@/modules/judicialFees/components/bill-timeline-modal.vue';
import BillAttributes from '@/modules/judicialFees/components/bill-attributes.vue';
import BillItemDetails from '@/modules/judicialFees/components/bill-item-details.vue';
import ObjectionRequestModal from '@/modules/judicialFees/components/objection-request-modal.vue';
import ObjectionRequestInfo from '@/modules/judicialFees/components/objection-request-info.vue';
import BillUpdateDetails from '@/modules/judicialFees/components/bill-update-details.vue';

export default {
  name: 'CaseFeesTab',
  components: {
    BillTimelineModal,
    BillAttributes,
    BillItemDetails,
    ObjectionRequestModal,
    ObjectionRequestInfo,
    BillUpdateDetails,
  },
  props: {
    caseObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      toHijriDate,
      items: [],
      loading: false,
      selectedBillObjectKey: null,
      selectedBillObjectKeyForObjection: null,
      selectedBillProviderIdForObjection: null,
      billActionTypeEnum,
      headers: [
        {
          value: 'invoiceNo',
          class: 'action-item pt-0 pl-0',
          text: this.local.judicialFees.headers.invoiceNo,
          isCustomTemplate: true,
        },
        {
          value: 'customerName',
          text: this.local.judicialFees.headers.customerName,
        },
        {
          value: 'identityNumber',
          text: this.local.judicialFees.headers.identityNumber,
        },
        {
          value: 'amount',
          text: this.local.judicialFees.headers.amount,
          formatter: (val) => { return `${val} ${this.local.judicialFees.sar}`; },
        },
        {
          value: 'creationDate',
          text: this.local.judicialFees.headers.creationDate,
          formatter: toHijriDate,
        },
        {
          value: 'expiryDate',
          text: this.local.judicialFees.headers.expiryDate,
          formatter: (val) => { return this.toHijriDate(val) || '---'; },
        },
        {
          value: 'statusName',
          text: this.local.judicialFees.headers.billStatusName,
        },
        {
          value: 'objectionStatus',
          text: this.local.judicialFees.headers.objectionStatus,
          formatter: (val) => { return val || '---'; },
        },
        {
          value: 'remainingObjectionDays',
          text: this.local.judicialFees.headers.lastObjectionDate,
          formatter: val => `${val} ${this.local.judicialFees.headers.day}`,
        },
        {
          value: 'action',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getCaseBills']),
    ...mapJudicialFeesActions(
      [
        'getBillItemDetails',
        'getBillAttributes',
        'getBillUpdateDetails',
      ]),
    loadData() {
      this.loading = true;
      this.getCaseBills(this.caseObjectKey)
        .then((res) => {
          this.items = res.data;
        })
        .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));
    },
    getBillDetails(bill, index) {
      if (!this.items.loaded) {
        const objectKey = bill.objectKey;
        this.$set(this.items[index], 'isLoading', true);
        Promise.all([
          this.getBillAttributes(objectKey),
          this.getBillItemDetails(objectKey),
          this.getBillUpdateDetails(objectKey),
        ]).then((results) => {
          this.$set(this.items[index], 'attributes', results[0].data);
          this.$set(this.items[index], 'itemDetails', results[1].data);
          this.$set(this.items[index], 'billUpdateDetails', results[2].data);
          this.$set(this.items[index], 'isBillUpdated', (results[2].data?.actionTypeId == billActionTypeEnum.refundDone || results[2].data?.actionTypeId == billActionTypeEnum.confirmUpdateInvoice));
          this.$set(this.items[index], 'loaded', true);
        })
          .finally(() => {
            this.$set(this.items[index], 'isLoading', false);
          });
      }
    },
    showBillTimelineModal(objectKey) {
      this.selectedBillObjectKey = objectKey;
    },
    showCreateBillObjectionRequest(billObjectKey, providerId) {
      this.selectedBillObjectKeyForObjection = billObjectKey;
      this.selectedBillProviderIdForObjection = providerId;
      this.$nextTick(() => {
        var modal = this.$refs.objectionRequestModal;
        modal.showModal();
      });
    },
    objectionRequestModalClose() {
      this.selectedBillNumberForObjection = null;
      this.selectedBillProviderIdForObjection = null;
      this.loadData();
    },
  },
};

</script>

<style lang="scss" scoped>
::v-deep .naj-box {
  border-top: 0px;

  .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    font-size: 23px !important;
  }
}

::v-deep .List__empty {
  margin-top: 0px !important;
}

::v-deep .info-item-box .info-item-details:nth-child(2) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

::v-deep .action-item {
  justify-content: flex-end;
}

::v-deep .empty {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 0 !important;
  .empty-title {
    font-size: 20px;
    line-height: 43px;
    margin: 0;
  }
}

.header-text {
  font-weight: 700;
  font-size: 18px;
  color: var(--app-dark-primary-color);
}
.header-sub-title {
  font-size: 14px;
  font-weight: 700;
}

.br0 {
  border-radius: 0px;
  ::v-deep.v-chip__content {
    color: #fff;
  }
}

.objection-box {
  border-right-color: var(--app-primary-color);
  border-right-style: solid;
  border-right-width: 4px;
}

::v-deep .v-chip.v-chip--outlined.v-chip.v-chip {
  background-color: #f7fbfb !important;
  border: 1px solid var(--app-primary-color) !important;
  border-radius: unset;

  .v-chip__content {
    button {
      color: var(--app-primary-color);
    }
  }
}
</style>